import * as React from 'react'
import styled from 'styled-typed'
import { AdditionalDataNotice } from 'uiComponents/charts/styleComponents'
import { SearchContainer } from 'uiComponents/search/searchField'
import SearchWithButtonField from 'uiComponents/search/searchWithButton'
import InCodesTableHeader from 'venue/bookingCodes/tableHeaderSlot'
import { PageAddButton } from 'uiComponents/buttons/pageAddButton'
import { Trans, useTranslation } from 'translations'

const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`

interface SearchSectionProps {
    barcodePoolsCount: number
    depletedPools: number
    onAddNew: () => void
}

export function SearchSection(props: SearchSectionProps) {
    const { t } = useTranslation()

    return (
        <InCodesTableHeader>
            <SearchContainer>
                <SearchWithButtonField />
                <Container>
                    <AdditionalDataNotice style={{ maxWidth: '33em' }}>
                        <Trans
                            i18nKey="venue.bookingCodes.barcodePools.search.availablePools"
                            count={props.barcodePoolsCount}
                            components={{ span: <span /> }}
                        />
                        {!!props.depletedPools && (
                            <>
                                {' '}
                                <Trans
                                    i18nKey="venue.bookingCodes.barcodePools.search.depletedPools"
                                    count={props.depletedPools}
                                    components={{ span: <span /> }}
                                />
                            </>
                        )}
                    </AdditionalDataNotice>
                    <PageAddButton
                        style={{ marginLeft: '1.5em' }}
                        onClick={props.onAddNew}
                        id="add-new-pool"
                        data-userpilot="barcodes-add-new-pool"
                    >
                        {t('venue.bookingCodes.addNew')}
                    </PageAddButton>
                </Container>
            </SearchContainer>
        </InCodesTableHeader>
    )
}
